export default __webpack_public_path__ + "static/media/asesoramiento.1d78da69.png";